import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Link from 'components/general/Link/Link';
import DateTime from 'components/general/DateTime/DateTime';
import AlertBody from 'screens/alerts/screens/single/components/AlertBody';
import { selectors } from './../ducks/article.duck';

const getMeta = createSelector(
  selectors.data,
  data => ([
    {
      key: 'when',
      title: 'When',
      info: (
        <DateTime {...R.prop('when', data)} />
      ),
    },
    {
      key: 'region',
      title: 'Region',
      info: (
        <Link
          to={{
            type: 'ALERTS_INDEX',
            query: {
              // Must match form-state for index filters,
              // expects an array of value/label entries.
              geographies: [{
                value: [R.path(['geography', 'slug'], data)],
                label: [R.path(['geography', 'title'], data)],
              }],
            },
          }}
        >
          {R.path(['geography', 'title'], data)}
        </Link>
      ),
    },
    {
      key: 'riskType',
      title: 'Alert type',
      info: (
        <Link
          to={{
            type: 'ALERTS_INDEX',
            query: {
              riskTypes: [R.path(['riskType', 'slug'], data)],
            },
          }}
        >
          {R.path(['riskType', 'title'], data)}
        </Link>
      ),
    },
  ]),
);

const getMatrixBlocks = createSelector(
  selectors.data,
  data => ([
    {
      key: 'generalContent',
      fields: {
        richText: { data: R.prop('detail', data) },
      },
    },
  ]),
);

const getViewOnMapAction = createSelector(
  selectors.data,
  data => ([
    {
      icon: 'map-marker',
      title: 'View on full map',
      to: {
        type: 'MAP',
        query: {
          marker: R.prop('id', data),
        },
      },
    },
  ]),
);

const getTags = createSelector(
  selectors.data,
  R.pipe(
    R.propOr([], 'contentTags'),
    R.reject(R.isEmpty),
    R.map(({ slug, title }) => ({
      label: title,
      type: 'secondary',
      to: {
        type: 'ALERTS_INDEX',
        query: {
          riskTypes: [],
          contentTags: [slug],
        },
      },
    })),
  ),
);

const AlertContent = connect(R.applySpec({
  title: R.pipe(
    selectors.data,
    R.prop('title'),
  ),
  category: R.always({
    title: 'Alerts',
    to: { type: 'ALERTS_INDEX' },
  }),
  matrixBlocks: getMatrixBlocks,
  viewOnMap: getViewOnMapAction,
  meta: getMeta,
  tags: getTags,
  loading: selectors.loading,
}))(AlertBody);

export default AlertContent;
